<div class="layoutBlock">
    <div class="columnThreeQuarter">
    
        <ng-container *ngIf="projects">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldSetContainer></ng-template>
			
			<res-project-panel 
			    [editMode]="editMode"
				[dDKey]="dDKeyProject"
				[selectedProjects]="projects"
			    [hisDynamicContent]="'fs.res.common.projects'"
				[dynamicComponent]="dynamicComponent"
				(selectedProjectsChange)="onProjectsChange($event)">
			</res-project-panel>
		</ng-container>

        <ng-container *ngIf="publications">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldSetContainer></ng-template>
			        
			<res-publication-panel
			    [editMode]="editMode"
				[dDKey]="dDKeyPublication"
				[selectedPublications]="publications"
				[isOptional]="publicationsAreOptional"
				[hisDynamicContent]="'fs.res.common.publications'"
			    [dynamicComponent]="dynamicComponent"
				(selectedPublicationsChange)="onPublicationsChange($event)">
			</res-publication-panel>
		</ng-container>
		
		<ng-container *ngIf="doctorates">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldSetContainer></ng-template>
			
			<res-doctorate-panel 
				[dDKey]="dDKeyDoctorates"
				[selectedDoctorates]="doctorates"
				(selectedDoctoratesChange)="onDoctoratesChange($event)">
			</res-doctorate-panel>
		</ng-container>

        <ng-container *ngIf="researchInfrastructures && hasRightsForResearchInfrastructure()">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldSetContainer></ng-template>
			        
			<res-infrastructure-panel
			    [editMode]="editMode"
			    [dDKey]="dDKeyResearchInfrastructures"
			    [selectedInfrastructures]="researchInfrastructures"
			    [hisDynamicContent]="'fs.res.common.researchInfrastructures'"
			    [dynamicComponent]="dynamicComponent"
			    (selectedInfrastructuresChange)="onInfrastructuresChange($event)"
			    (onBeforeNavigate)="onBeforeNavigate.emit($event)">
			</res-infrastructure-panel>
        </ng-container>
        
        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>
        
        <ng-container *ngIf="customContentPanel">
            <ng-content select="[customContentPanel]"></ng-content>
            
            <!-- #anchor dynamic field container -->
            <ng-template #dynamicFieldSetContainer></ng-template>
         </ng-container>
            
    </div>
</div>